<template>
    <div class="input-group">
        <div class="input-group-prepend">
            <span class="input-group-text" id="">First and last name</span>
        </div>
        <input type="text" class="form-control">
        <input type="text" class="form-control">
    </div>
</template>

<script>
export default {
name: "TimeInputComponent"
}
</script>

<style scoped>

</style>
